export const JOURNEY_ANSWER_STATUS = Object.freeze({
  UNCONFIRMED: 'unconfirmed',
  CONFIRMED: 'confirmed',
  SKIPPED: 'skipped',
});

export const JOURNEY_ANSWER_ORIGIN = Object.freeze({
  AI_SUGGESTED: 'ai_suggested',
  CAREGIVER_AUTHORED: 'caregiver_authored',
});

export const mergeJourneyAnswers = ({
  questions = [], proposedAnswers = [], savedAnswers = [], answerFreshness = [],
}) => {
  const proposedById = new Map(proposedAnswers.map((answer) => [answer.questionId, answer]));
  const savedById = new Map(savedAnswers.map((answer) => [answer.questionId, answer]));
  const freshnessById = new Map(answerFreshness.map((item) => [item.questionId, item]));
  return questions.map((question) => {
    const saved = savedById.get(question.id);
    const proposed = proposedById.get(question.id);
    const candidateFreshness = freshnessById.get(question.id) || null;
    const freshness = saved?.evidenceFingerprint
      && saved.evidenceFingerprint === candidateFreshness?.currentEvidenceFingerprint
      ? null : candidateFreshness;
    if (saved?.status === JOURNEY_ANSWER_STATUS.CONFIRMED
      || saved?.status === JOURNEY_ANSWER_STATUS.SKIPPED) {
      return {
        question, proposed: proposed || null, answer: saved, freshness,
      };
    }
    return {
      question,
      proposed: proposed || null,
      freshness,
      answer: saved || (proposed ? {
        ...proposed,
        status: JOURNEY_ANSWER_STATUS.UNCONFIRMED,
        origin: JOURNEY_ANSWER_ORIGIN.AI_SUGGESTED,
      } : null),
    };
  });
};

export const upsertJourneyAnswer = (answers = [], nextAnswer) => [
  ...answers.filter((answer) => answer.questionId !== nextAnswer.questionId),
  nextAnswer,
];

export const getFinalizedJourneyAnswers = (answers = []) => answers.filter((answer) => (
  answer.status === JOURNEY_ANSWER_STATUS.CONFIRMED
  && Boolean(String(answer.confirmedText || '').trim())
));
